import { render, staticRenderFns } from "./RiskModelResultTable.vue?vue&type=template&id=60866d60&scoped=true&"
import script from "./RiskModelResultTable.vue?vue&type=script&lang=js&"
export * from "./RiskModelResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60866d60",
  null
  
)

export default component.exports